export default __webpack_public_path__ + "static/media/discount.0311c04f.svg";